(() => {
 'use strict';
 const labelsNode=document.querySelector('[data-br-world-script]');
 const labels={play:labelsNode?.dataset.play||'Video abspielen',pause:labelsNode?.dataset.pause||'Video pausieren'};
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const items=new Map();let active=null,manual=null,frame=0,apiPromise;
 const autoAllowed=()=>!reduce.matches&&!navigator.connection?.saveData;
 function youtubeAPI(){
  if(window.YT?.Player)return Promise.resolve(window.YT);
  if(apiPromise)return apiPromise;
  apiPromise=new Promise((resolve,reject)=>{
   const previous=window.onYouTubeIframeAPIReady;
   const timer=setTimeout(()=>reject(new Error('YouTube timeout')),15000);
   window.onYouTubeIframeAPIReady=()=>{clearTimeout(timer);previous?.();resolve(window.YT);};
   const tag=document.createElement('script');tag.src='https://www.youtube.com/iframe_api';tag.async=true;
   tag.onerror=()=>{clearTimeout(timer);tag.remove();reject(new Error('YouTube unavailable'));};document.head.append(tag);
  }).catch(error=>{apiPromise=null;throw error;});return apiPromise;
 }
 function paint(item,playing){
  item.playing=playing;item.el.dataset.brPlaying=String(playing);
  item.el.classList.toggle(item.native?'is-playing':'is-ready',playing||item.hasFrame);
  if(playing)item.hasFrame=true;
  if(item.button){item.button.textContent=playing?labels.pause:labels.play;item.button.setAttribute('aria-pressed',String(playing));}
 }
 function stop(item){item.wanted=false;if(item.native)item.el.pause();else if(item.ready)item.player.pauseVideo();paint(item,false);}
 async function load(item){
  if(item.loading||item.ready||item.dead)return;item.loading=true;
  try{
   if(item.native){
    const sources=[...item.el.querySelectorAll('source[data-src]')].sort((a,b)=>Number(a.dataset.width||1920)-Number(b.dataset.width||1920));
    const target=matchMedia('(max-width:749px)').matches?860:1280;
    const source=sources.find(s=>Number(s.dataset.width||1920)>=target)||sources.at(-1);
    if(source)item.el.src=source.dataset.src;
    item.el.muted=true;item.el.load();item.ready=true;item.loading=false;
   }else{
    const api=await youtubeAPI();if(item.dead)return;
    const iframe=document.createElement('iframe');iframe.title=item.el.dataset.brTitle||'Herstellerfilm';iframe.tabIndex=-1;
    iframe.allow='autoplay; encrypted-media; fullscreen';iframe.referrerPolicy='strict-origin-when-cross-origin';
    iframe.src='https://www.youtube-nocookie.com/embed/'+item.el.dataset.brYoutube+'?enablejsapi=1&autoplay=0&mute=1&controls=0&playsinline=1&loop=1&playlist='+item.el.dataset.brYoutube+'&rel=0&origin='+encodeURIComponent(location.origin);
    item.el.replaceChildren(iframe);
    item.player=new api.Player(iframe,{events:{
     onReady:()=>{if(item.dead)return;item.ready=true;item.loading=false;item.player.mute();if(item.wanted)play(item);},
     onStateChange:e=>{if(item.dead)return;if(e.data===1){if(active!==item||document.hidden){item.player.pauseVideo();return;}paint(item,true);}if(e.data===2)paint(item,false);if(e.data===0&&item.wanted){item.player.seekTo(0,true);item.player.playVideo();}},
     onError:()=>{item.error=true;item.el.dataset.brError='true';paint(item,false);},
     onAutoplayBlocked:()=>{item.el.dataset.brBlocked='true';paint(item,false);}
    }});
   }
  }catch{item.loading=false;item.el.dataset.brError='true';}
 }
 async function play(item){
  if(item.dead||document.hidden||!item.wanted)return;
  if(!item.ready){await load(item);if(!item.ready||!item.wanted)return;}
  item.lastAttempt=performance.now();item.attempts++;
  try{
   if(item.native){item.el.muted=true;await item.el.play();if(active!==item||!item.wanted||document.hidden){item.el.pause();return;}paint(item,true);}
   else{item.player.mute();item.player.playVideo();}
  }catch{paint(item,false);item.el.dataset.brBlocked='true';}
 }
 function visibleScore(item){
  const r=item.screen.getBoundingClientRect(),h=innerHeight;
  const pixels=Math.max(0,Math.min(r.bottom,h)-Math.max(r.top,0));
  const ratio=pixels/Math.min(r.height,h);
  return ratio>=.3?ratio*1000-Math.abs((r.top+r.bottom)/2-h/2)*.1:-1;
 }
 function reconcile(){
  frame=0;let next=null,best=-1;
  if(!document.hidden){
   if(manual&&visibleScore(manual)>=0&&!manual.pausedByUser)next=manual;
   else{manual=null;if(autoAllowed())items.forEach(item=>{const score=visibleScore(item);if(!item.pausedByUser&&score>best){best=score;next=item;}});}
  }
  if(next===active)return;
  if(active)stop(active);active=next;
  if(active){active.wanted=true;active.attempts=0;play(active);}
 }
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(reconcile);};
 const approach=new IntersectionObserver(entries=>{entries.forEach(e=>{const item=[...items.values()].find(i=>i.screen===e.target);if(e.isIntersecting&&item&&autoAllowed())load(item);});schedule();},{rootMargin:'300px 0px',threshold:0});
 function init(root=document){
  root.querySelectorAll('[data-br-youtube],.br-video').forEach(el=>{
   if(items.has(el))return;
   const section=el.closest('.br-story,.br-hero,.br-card');if(!section)return;
   const native=el.matches('video');
   const item={el,native,screen:el.closest('.br-cinema__screen')||el,button:section.querySelector(native?'[data-br-toggle]':'[data-br-film-toggle]'),ready:false,wanted:false,playing:false,attempts:0};
   item.click=()=>{
    if(item.playing){item.pausedByUser=true;if(manual===item)manual=null;stop(item);if(active===item)active=null;schedule();}
    else{item.pausedByUser=false;item.error=false;item.attempts=0;manual=item;if(active&&active!==item)stop(active);active=item;item.wanted=true;play(item);}
   };
   item.button?.addEventListener('click',item.click);items.set(el,item);approach.observe(item.screen);
  });schedule();
 }
 // Measure advancing playback time, not just player readiness.
 const health=setInterval(()=>{
  items.forEach(item=>{
   if(!item.ready||item.dead)return;
   const time=item.native?item.el.currentTime:item.player.getCurrentTime?.();
   if(Number.isFinite(time)){item.el.dataset.brTime=time.toFixed(2);if(item.wanted&&time!==item.lastTime&&time>0){paint(item,true);delete item.el.dataset.brBlocked;}item.lastTime=time;}
   if(item===active&&item.wanted&&!item.playing&&!item.error&&item.attempts<4&&performance.now()-(item.lastAttempt||0)>1800)play(item);
  });
 },750);
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
 document.addEventListener('visibilitychange',schedule);reduce.addEventListener('change',schedule);
 document.addEventListener('pointerdown',()=>{if(active&&!active.playing&&active.wanted){active.attempts=0;play(active);}},{passive:true});
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>items.forEach((item,el)=>{if(e.target.contains(el)){item.dead=true;stop(item);approach.unobserve(item.screen);item.button?.removeEventListener('click',item.click);item.player?.destroy();items.delete(el);if(active===item)active=null;}}));
 addEventListener('pagehide',()=>{items.forEach(stop);active=null;});
 addEventListener('pageshow',schedule);
 init();
})();
